import { createRouter, createWebHistory } from 'vue-router'
import 'vue-router'
import {
  handleAuthorizationRedirect,
  optionallyRequireAuthorization,
  requireAuthorization
} from './navigation-guards/authorization'

declare module 'vue-router' {
  interface RouteMeta {
    theme?: 'dark' | 'light' // By default the page will be in light mode
  }
}

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/cart'
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import('../views/CartView.vue')
    },
    {
      path: '/cart/add',
      name: 'cart-add',
      component: () => import('../views/CartView.vue'),
      beforeEnter: optionallyRequireAuthorization
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import('../views/PaymentView.vue'),
      beforeEnter: requireAuthorization
    },
    {
      path: '/success/:id',
      name: 'payment-success',
      component: () => import('../views/SuccessView.vue'),
      meta: { theme: 'dark' },
      beforeEnter: requireAuthorization
    },
    {
      path: '/pending/:id',
      name: 'purchase-pending',
      component: () => import('../views/PendingView.vue'),
      meta: { theme: 'dark' },
      beforeEnter: requireAuthorization
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'page-not-found',
      component: () => import('../views/PageNotFoundView.vue'),
      meta: { theme: 'dark', gtm: 'PageNotFound' }
    }
  ]
})

// All routes handle redirects from SSO for authorization. Note that this is called before any per-route navigation
// guards.
router.beforeEach(handleAuthorizationRedirect)

export default router
